// Module
var code = "<button class=\"sps-btn sps-btn-dim sps-btn-dim--gray sps-btn-padding-xs\" data-bind=\"click: OnClick,\r\n              tooltip: Tooltip\"> <i class=\"fa-solid fa-arrows-rotate size-4\"></i> </button>";
// Exports
export default code;